import { ChangeDetectionStrategy, Component, effect, inject, input, output } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import { CompanyNamedLookupRequest, CompanyNamedLookupResponse } from '../../company.model';

@Component({
  selector: 'app-division-form',
  imports: [ReactiveFormsModule, ...SharedMaterialUIModule],
  templateUrl: './division-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DivisionFormComponent {
  private readonly formBuilder = inject(FormBuilder);

  readonly initialValue = input<CompanyNamedLookupResponse | null>(null);
  readonly companyId = input.required<string>();
  readonly label = input('Name');
  readonly saving = input(false);
  readonly submitted = output<CompanyNamedLookupRequest>();

  readonly divisionForm = this.formBuilder.group({
    name: ['', Validators.required],
  });

  constructor() {
    effect(() => {
      this.divisionForm.reset({
        name: this.initialValue()?.name ?? '',
      });
    });
  }

  protected submit(): void {
    if (this.divisionForm.invalid) {
      this.divisionForm.markAllAsTouched();
      return;
    }

    const request: CompanyNamedLookupRequest = {
      companyId: this.companyId(),
      name: this.divisionForm.getRawValue().name?.trim() ?? '',
    };

    this.submitted.emit(request);
  }
}
